
export const audio = {
  namespaced: true,//为当前模块开启独立的命名空间
  state:{
    playInfo:{},
    audioDuration:0,
    audioCurrentTime:0,
    percent:0,
    oldPercent:0,
    playState:false,
    monitor:false,
    playOrder:'order',
    audioEnd:false,
    noUpdate:false
  },
  
  mutations:{
    updatePlayInfo(state,obj){
      state.playInfo = obj
    },
    updateDuration(state,num){
      state.audioDuration = num
    },
    updateCurTime(state,num){
      state.audioCurrentTime = num
    },
    updatePlayState(state,curState){
      state.playState = curState
    },
    updateMonitor(state,monitor){
      state.monitor = monitor
    },
    updatePlayOrder(state,order){
      state.playOrder= order
    },
    audioEnd(state,isEnd){
      state.audioEnd= isEnd
      if(isEnd){
        state.playState = false
      }
    },
    
    
  },
  actions:{

  },

  getters: {
    getPercent(state){
      // if (state.monitor) return  state.oldPercent
      if (!state.playInfo || !state.playInfo.src || state.audioDuration==0) { return 0 }
      let percent = Math.ceil((state.audioCurrentTime / state.audioDuration).toFixed(4) * 100);
      state.oldPercent = percent
      return percent;
    },
    getCurAudio(state){
      if (!state.playInfo || !state.playInfo.src ) { return null }
      return state.playInfo
    },

  },
}